(function() {
  'use strict';
  
  const DY = window.DY || {};
  let prevCart = fetch("/cart.js").then((resp) => resp.json());

  function debounce(func, timeout = 300){
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => { func.apply(this, args); }, timeout);
    };
  }

  $('body').on('afterAddItem.ajaxCart', async function(e, line_item, form) {
    // Safety check
    if (!line_item) {
      console.warn('Dynamic Yield: line_item is undefined in afterAddItem');
      return;
    }
    
    const eventData = {
      name: "Add to Cart",
      properties: {
        dyType: "add-to-cart-v1",
        value: line_item.final_price / 100,
        currency: "CAD",
        productId: line_item.sku,
        quantity: 1,
      }
    };
    
    if (line_item.options_with_values && Array.isArray(line_item.options_with_values)) {
      for(const option of line_item.options_with_values) {
        eventData.properties[option.name.toLowerCase()] = option.value;
      }
    }
    
    const response = await fetch('/cart.js');
    const cart = await response.json();
    prevCart = cart;
    
    if (!cart || !cart.items || !Array.isArray(cart.items)) {
      console.warn('Dynamic Yield: Invalid cart data in afterAddItem', cart);
      return;
    }
    
    eventData.properties.cart = cart.items.map(item => {
      const cartData = {
        quantity: item.quantity,
        productId: item.sku,
        itemPrice: item.final_price / 100,
      };
        
      if (item.options_with_values && Array.isArray(item.options_with_values)) {
        for(const option of item.options_with_values) {
          cartData[option.name.toLowerCase()] = option.value;
        }
      }
      
      return cartData;
    });

    DY.API("event", eventData);
  });

  $('body').on('click', '.cart__remove', async function(e) {
    const row = $(this).closest('.cart__row');
    const index = row.data('index') - 1;
    try {
      prevCart = await fetch('/cart.js').then(resp => resp.json());
      
      // Safety check
      if (!prevCart || !prevCart.items || !prevCart.items[index]) {
        console.warn('Dynamic Yield: Invalid cart or item index', { prevCart, index });
        return;
      }
      
      const item = prevCart.items[index];

      if (!item) return;

      const eventData = {
        name: "Remove from Cart",
        properties: {
          dyType: "remove-from-cart-v1",
          value: (item.final_price / 100) * item.quantity,
          currency: "CAD",
          productId: item.sku,
          quantity: item.quantity
        }
      };
      
      if (item.options_with_values && Array.isArray(item.options_with_values)) {
        for(const option of item.options_with_values) {
          eventData.properties[option.name.toLowerCase()] = option.value;
        }
      }

      prevCart.items.splice(index, 1);
  
      eventData.properties.cart = prevCart.items.map(item => {
        const cartData = {
          quantity: item.quantity,
          productId: item.sku,
          itemPrice: item.final_price / 100,
        };
          
        if (item.options_with_values && Array.isArray(item.options_with_values)) {
          for(const option of item.options_with_values) {
            cartData[option.name.toLowerCase()] = option.value;
          }
        }
        
        return cartData;
      });
  
      DY.API("event", eventData);
    } catch(e) {
      console.error(e);
    }
  });

  $('body').on('afterChangeItem.ajaxCart', async function(e, line, quantity, cart, plusOrMinus) {
    let line_item;
    let qtyChanged;

    const tmpCart = await prevCart;
    const prevItems = tmpCart?.items || [];
    const currItems = cart?.items || [];

    if (quantity === 0) {
      const prevItem = prevItems.find(
        p => !currItems.some(c => c.key === p.key)
      );

      if (!prevItem) return;

      line_item = prevItem;
      qtyChanged = -prevItem.quantity;

    } else {
      const prevItem = prevItems[line - 1];
      const currItem = currItems[line - 1];

      if (!prevItem || !currItem) return;

      line_item = currItem;
      qtyChanged = currItem.quantity - prevItem.quantity;
    }

    if (!line_item || !qtyChanged) return;

    const eventData = {
      name: qtyChanged > 0 ? "Add to Cart" : "Remove from Cart",
      properties: {
        dyType: qtyChanged > 0 ? "add-to-cart-v1" : "remove-from-cart-v1",
        value: (line_item.final_price / 100) * Math.abs(qtyChanged),
        currency: "CAD",
        productId: line_item.sku,
        quantity: Math.abs(qtyChanged)
      }
    };
    
    if (line_item.options_with_values && Array.isArray(line_item.options_with_values)) {
      for(const option of line_item.options_with_values) {
        eventData.properties[option.name.toLowerCase()] = option.value;
      }
    }

    if (!cart || !cart.items || !Array.isArray(cart.items)) {
      console.warn('Dynamic Yield: Invalid cart data in afterChangeItem cart mapping', cart);
      return;
    }

    eventData.properties.cart = cart.items.map(item => {
      const cartData = {
        quantity: item.quantity,
        productId: item.sku,
        itemPrice: item.final_price / 100,
      };
        
      if (item.options_with_values && Array.isArray(item.options_with_values)) {
        for(const option of item.options_with_values) {
          cartData[option.name.toLowerCase()] = option.value;
        }
      }
      
      return cartData;
    });

    DY.API("event", eventData);
  });

  document.body.addEventListener('click', (e) => {
    if(e.target.classList.contains('ctm_radios')) {
      DY.API("event", {
        name: "Change Attribute",
        properties: {
          dyType: "change-attr-v1",
          attributeType: 'Size',
          attributeValue: e.target.dataset.value,
        }
      });
    } else if(e.target.classList.contains('ais-facet--checkbox')) {
      let elm = e.target;      
      const facet = e.target.closest('.listing-filters__group');
      if (!facet) return;
      const type = facet.querySelector('.filter-group__title')?.innerText.trim();
      if (!type) return;
      DY.API("event", {
        name: "Filter Items",
        properties: {
          dyType: "filter-items-v1",
          filterType: type,
          filterStringValue: elm.nextElementSibling.innerText
        }
      });
    } else if(e.target.classList.contains('ajaxcart__qty--remove')) {
      const elm = e.target;
      const id = elm.dataset.id.split(':')[0];
      DY.API("event", {
        name: "Filter Items",
        properties: {
          dyType: "filter-items-v1",
          filterType: type,
          filterStringValue: elm.innerText
        }
      });
    } else if (e.target.classList.contains('sizeguide_btn') || e.target.closest('.sizeguide_btn')) {
      DY.API('event', {
        name: 'Size Guide Clicked',
        properties: {
          product: document.querySelector('.product-single-title').innerText
        }
      })
    } else if (e.target.closest('#recently-viewed-products')) {
      DY.API('event', {
        name: 'Recently Viewed Clicked',
        properties: {
          product: document.querySelector('.product-single-title').innerText,
          clickedProduct: e.target.closest('.grid-product__content').querySelector('.product_meta_wrap .h6 a').innerText,
        }
      });
    }
  });

  const search = document.querySelector('.site-header__search input');
  if(search) {
    search.addEventListener('keyup', debounce((evt) => {
      const keywords = evt.target.value;
      DY.API("event", {
        name: "Keyword Search",
        properties: {
          dyType: "keyword-search-v1",
          keywords,
        }
      });
    }));
  }

  const searchMobile = document.querySelector('.site-header__search.mobile__search input[type=search]');
  if(searchMobile) {
    searchMobile.addEventListener('keyup', debounce((evt) => {
      const keywords = evt.target.value;
      DY.API("event", {
        name: "Keyword Search",
        properties: {
          dyType: "keyword-search-v1",
          keywords,
        }
      });
    }));
  }
  
  const CUSTOMER_REGISTER_SEEN = 'customer_register_seen';
  const CUSTOMER_LOGIN_SEEN = 'customer_login_seen';

  if(document.getElementById("create_customer")) {
    window.sessionStorage.removeItem(CUSTOMER_LOGIN_SEEN);
    window.sessionStorage.setItem(CUSTOMER_REGISTER_SEEN, true);
  }

  if(document.getElementById("customer_login")) {
    // remove register here as they will
    window.sessionStorage.removeItem(CUSTOMER_REGISTER_SEEN);
    window.sessionStorage.setItem(CUSTOMER_LOGIN_SEEN, true);
  }

  if (typeof customer !== 'undefined') {
    const plainEmail = customer.email.toLowerCase();
    if(window.sessionStorage.getItem(CUSTOMER_REGISTER_SEEN) && customer && customer.email) {
      console.log("Before Hashing (signup):", plainEmail);
      DY.API("event", {
        name: "Signup",
        properties: {
          dyType: "signup-v1",
          hashedEmail: DYO.dyhash.sha256(plainEmail), // SHA256 encoding of the lowercase email, if known (optional)
        }
      });
      window.sessionStorage.removeItem(CUSTOMER_REGISTER_SEEN);
    }
    if (window.sessionStorage.getItem(CUSTOMER_LOGIN_SEEN) && customer && customer.email) {
      console.log("Before Hashing (login):", plainEmail);
      DY.API("event", {
        name: "Login",
        properties: {
          dyType: "login-v1",
          hashedEmail: DYO.dyhash.sha256(plainEmail), // SHA256 encoding of the lowercase email, if known (optional)
        }
      });
      window.sessionStorage.removeItem(CUSTOMER_LOGIN_SEEN);
    }
  }

  var newsletter = [].slice.call(document.querySelectorAll('.newsletter, .footer__newsletter, .klaviyo-form'));
  newsletter.forEach(block => {
    block.querySelector('form').addEventListener('submit', function() {
      DY.API("event", {
        name: "Newsletter Subscription",
        properties: {
          dyType: "newsletter-subscription-v1",
          hashedEmail: DYO.dyhash.sha256(block.querySelector('input[type="email"]').value.toLowerCase()) // SHA256 encoding of the lowercase email,
          // in textual hexadecimal representation
        }
      });
    });
  });

  document.body.addEventListener('change', (e) => {
    if(e.target.classList.contains('ais-SortBy-select')) {
      DY.API("event", {
        name: "Sort Items",
        properties: {
          dyType: "sort-items-v1",
          sortBy: e.target.value,
          sortOrder: "ASC"
        }
      });
    }
  });

  if(document.body.classList.contains('template-index')) {
    const sections = document.querySelectorAll('.main-content .shopify-section a');
    sections.forEach((sectionLink) => {
      sectionLink.addEventListener('click', (e) => {
        try {
          let elm = e.currentTarget;
          let innerIndex = 1;
          const section = e.target.closest('.shopify-section');
          if(!elm.getAttribute('href')) {
            return;
          }

          if(elm.closest('.brand__flex')) {
            elm = elm.closest('li');
            innerIndex = [...elm.parentElement.childNodes].indexOf(elm) + 1;
          } else if (elm.closest('.grid__item')) {
            elm = elm.closest('.grid__item');
            innerIndex = [...elm.parentElement.childNodes].indexOf(elm) + 1;
          }

          DY.API('event', {
            name: 'Homepage Click',
            properties: {
              position: [...section.parentElement.childNodes].indexOf(section),
              innerPosition: innerIndex,
              url: e.currentTarget.href,
            }
          });
        } catch(err) {
          console.error(err);
        }
      });
    })
  }

  const footerSocial = document.querySelectorAll('.footer__social-icons a');
  footerSocial.forEach(link => {
    link.addEventListener('click', e => {
      DY.API('event', {
        name: 'Footer Social Media Clicked',
        properties: {
          url: link.href
        }
      });
    });
  });

  var recentlyViewed = document.getElementById('shopify-section-recently-viewed');
  if(recentlyViewed) {
    const isInViewport = debounce(function() {
      const rect = recentlyViewed.getBoundingClientRect();
      if (rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth)) {
          DY.API('event', {
            name: 'PDP Recommendation Seen',
            properties: {}
          });
          window.removeEventListener('scroll', isInViewport);
      } 
    }, 50);
    
    window.addEventListener('scroll', isInViewport);
    isInViewport();
  }

  const cartViewed = document.querySelector('.cart_upsell_section');
  if(cartViewed) {
    const isInViewportCart = debounce(function() {
      const rect = cartViewed.getBoundingClientRect();
      if (rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth)) {
          DY.API('event', {
            name: 'Cart Recommendation Seen',
            properties: {}
          });
          window.removeEventListener('scroll', isInViewportCart);
      }
    }, 50);
    
    window.addEventListener('scroll', isInViewportCart);
    isInViewportCart();
  }

  window.addEventListener('scroll', () => {
    const scrollPosition = window.scrollY + window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;

    if (scrollPosition >= documentHeight * 0.9) {
        DY.API('event', {
          name: 'PLP 90% scrolled',
          properties: {}
        });
    }
  });

})();